// Явный набор иконок (lucide) — держим бандл лёгким, без импорта всей библиотеки.
// Имена соответствуют значениям поля icon в дефолтах блоков (PascalCase).
import {
    BadgePercent,
    BadgeRussianRuble,
    Banknote,
    BarChart3,
    Building,
    Building2,
    Bus,
    Car,
    CheckCircle,
    CheckCircle2,
    ChevronLeft,
    ChevronRight,
    Clock,
    Coins,
    CreditCard,
    Crown,
    DollarSign,
    Download,
    Eye,
    GraduationCap,
    Globe,
    HandCoins,
    Handshake,
    Headset,
    Hotel,
    Mail,
    MapPin,
    Menu,
    Pencil,
    Percent,
    Network,
    Phone,
    PiggyBank,
    Plane,
    Plus,
    RussianRuble,
    Save,
    Search,
    Shield,
    ShieldCheck,
    Trash2,
    Train,
    TrainFront,
    TrendingUp,
    Upload,
    Users,
    Wallet,
    X,
    Zap,
} from "lucide-vue-next";

export const icons = {
    BadgePercent,
    BadgeRussianRuble,
    Banknote,
    BarChart3,
    Building,
    Building2,
    Bus,
    Car,
    CheckCircle,
    CheckCircle2,
    ChevronLeft,
    ChevronRight,
    Clock,
    Coins,
    CreditCard,
    Crown,
    DollarSign,
    Download,
    Eye,
    GraduationCap,
    Globe,
    HandCoins,
    Handshake,
    Headset,
    Hotel,
    Mail,
    MapPin,
    Menu,
    Network,
    Pencil,
    Percent,
    Phone,
    PiggyBank,
    Plane,
    Plus,
    RussianRuble,
    Save,
    Search,
    Shield,
    ShieldCheck,
    Trash2,
    Train,
    TrainFront,
    TrendingUp,
    Upload,
    Users,
    Wallet,
    X,
    Zap,
};

export function resolveIcon(name) {
    return icons[name] || CheckCircle;
}
